/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import React from 'react';
import Loadable from 'react-loadable';
import FavouriteContact from '../components/Account/FavouriteContact';
import MyAddressList from '../components/Account/My Address List';
import MyAccountHeadline from '../components/Account/MyAccountHeadline';
import MyAccountTabsComponent from '../components/Account/MyAccountTabsComponent';
import MyAccountDeviceRegistration from '../components/Account/MyDevices/DeviceRegistration/MyAccountDeviceRegistration';
import AddDevice from '../components/Account/MyDevices/DeviceRegistration/MyAccountDeviceRegistration/AddDevice';
import ErrorMessageWithSupport from '../components/Account/MyDevices/DeviceRegistration/MyAccountDeviceRegistration/AddDevice/ErrorMessageWithSupport';
import ConfirmationBanner from '../components/Account/MyDevices/DeviceRegistration/MyAccountDeviceRegistration/ConfirmationBanner';
import DeviceConfirmationButtons from '../components/Account/MyDevices/DeviceRegistration/MyAccountDeviceRegistration/DeviceConfirmationButtons';
import DevicesAccountInformation from '../components/Account/MyDevices/DeviceRegistration/MyAccountDeviceRegistration/DevicesAccountInformation';
import NewAddedDeviceList from '../components/Account/MyDevices/DeviceRegistration/MyAccountDeviceRegistration/NewAddedDeviceList';
import OverlayFindSerialAndArticle from '../components/Account/MyDevices/DeviceRegistration/MyAccountDeviceRegistration/OverlayFindSerialAndArticle';
import RegisterDevicesList from '../components/Account/MyDevices/DeviceRegistration/MyAccountDeviceRegistration/RegisterDevicesList';
import TitleAndDescription from '../components/Account/MyDevices/DeviceRegistration/MyAccountDeviceRegistration/TitleAndDescription';
import MyAccountDeviceList from '../components/Account/MyDevices/MyAccountDeviceList';
import AddDeviceButton from '../components/Account/MyDevices/MyAccountDeviceList/AddDeviceButton';
import DeviceFilters from '../components/Account/MyDevices/MyAccountDeviceList/DeviceFilters';
import DeviceList from '../components/Account/MyDevices/MyAccountDeviceList/DeviceList';
import DeviceCard from '../components/Account/MyDevices/MyAccountDeviceList/DeviceList/DeviceCard';
import MyNewsletters from '../components/Account/MyNewsletters';
import FulfillmentStatusTag from '../components/Account/MyOrders/FulfillmentStatusTag';
import LineItemsMobile from '../components/Account/MyOrders/LineItemsMobile';
import MyAccountOrderDetails from '../components/Account/MyOrders/MyAccountOrderDetails';
import MyAccountOrderList from '../components/Account/MyOrders/MyAccountOrderList';
import OrderListMobile from '../components/Account/MyOrders/OrderListMobile';
import MyProfileComponent from '../components/Account/MyProfileComponent';
import AccountInformations from '../components/Account/MyProfileComponent/AccountInformations';
import CompanyInformations from '../components/Account/MyProfileComponent/CompanyInformations';
import PersonalInformations from '../components/Account/MyProfileComponent/PersonalInformations';
import AlertBox from '../components/Common/AlertBox';
import BackToLink from '../components/Common/BackToLink';
import CareerPromotionBox from '../components/Common/CareerPromotionBox';
import CategoryPipeDate from '../components/Common/CategoryPipeDate';
import ContentAccordion from '../components/Common/Content/Accordion/ContentAccordion';
import ContentAccordionElements from '../components/Common/Content/Accordion/ContentAccordionElements';
import BacktoOverview from '../components/Common/Content/Events/BacktoOverview';
import EventInformation from '../components/Common/Content/Events/EventInformation';
import EventMap from '../components/Common/Content/Events/EventMap';
import ImageWithRichText from '../components/Common/Content/ImageWithRichText';
import ReadMoreRichText from '../components/Common/Content/ReadMoreRichText';
import RichTextTeaser from '../components/Common/Content/RichTextTeaser';
import VideoWithRichText from '../components/Common/Content/VideoWithRichText';
import Dialog from '../components/Common/Dialog';
import DownloadBox from '../components/Common/DownloadBox';
import DownloadItem from '../components/Common/DownloadBox/DownloadItem';
import Dropdown from '../components/Common/Dropdown';
import FilterToggle from '../components/Common/FilterToggle';
import GatedDownload from '../components/Common/GatedDownload';
import GeneralLink from '../components/Common/GeneralLink';
import HeaderTableTeaser from '../components/Common/HeaderTableTeaser';
import TableRowTeaser from '../components/Common/HeaderTableTeaser/TableRowTeaser';
import HeadlineRichtextTeaser from '../components/Common/HeadlineRichtextTeaser';
import HeadlineWithTitleAndSubtitle from '../components/Common/HeadlineWithTitleAndSubtitle';
import HeroExpertise from '../components/Common/Hero Expertise';
import HeroListingTitleWithOverline from '../components/Common/HeroListingTitleWithOverline';
import Icon from '../components/Common/Icon';
import IconLink from '../components/Common/IconLink';
import ImageLeftTeaser from '../components/Common/ImageLeftTeaser';
import ImageRightTeaser from '../components/Common/ImageRightTeaser';
import AXAGImageSlider169 from '../components/Common/ImageSliderContainer/AXAGImageSlider169';
import AXAGImageSlider31 from '../components/Common/ImageSliderContainer/AXAGImageSlider31';
import ImageSlider169 from '../components/Common/ImageSliderContainer/ImageSlider169';
import ImageSlider31 from '../components/Common/ImageSliderContainer/ImageSlider31';
import LAGImageSlider169 from '../components/Common/ImageSliderContainer/LAGImageSlider169';
import LAGImageSlider31 from '../components/Common/ImageSliderContainer/LAGImageSlider31';
import ImageTextRight from '../components/Common/ImageTextRight';
import InlineConfirmationDialog from '../components/Common/InlineConfirmationDialog';
import InlineError from '../components/Common/InlineError';
import LanguageFlyout from '../components/Common/LanguageFlyout';
import LightboxVideo from '../components/Common/LightboxVideo';
import LinkerCarouselComponent from '../components/Common/LinkerCarouselComponent';
import AXAGLinkerCarousel from '../components/Common/LinkerCarouselComponent/AXAGLinkerCarousel';
import LAGLinkerCarousel from '../components/Common/LinkerCarouselComponent/LAGLinkerCarousel';
import LinkerCarousel from '../components/Common/LinkerCarouselComponent/LinkerCarousel';
import WELDYLinkerCarousel from '../components/Common/LinkerCarouselComponent/WELDYLinkerCarousel';
import ListingPageTitleWithDescription from '../components/Common/ListingPageTitleWithDescription';
import Logo from '../components/Common/Logo';
import MediaGalleryTeaser from '../components/Common/MediaGalleryTeaser';
import ObjectSlider from '../components/Common/ObjectSlider';
import PageDescriptionTeaser from '../components/Common/PageDescriptionTeaser';
import PageLinker from '../components/Common/PageLinker';
import PageLinkerAutomaticallyComponent from '../components/Common/PageLinkerAutomaticallyComponent';
import AXAGPageLinkerAutomatically from '../components/Common/PageLinkerAutomaticallyComponent/AXAGPageLinkerAutomatically';
import LAGPageLinkerAutomatically from '../components/Common/PageLinkerAutomaticallyComponent/LAGPageLinkerAutomatically';
import PageLinkerAutomatically from '../components/Common/PageLinkerAutomaticallyComponent/PageLinkerAutomatically';
import WELDYPageLinkerAutomatically from '../components/Common/PageLinkerAutomaticallyComponent/WELDYPageLinkerAutomatically';
import PageLinkerList from '../components/Common/PageLinkerList';
import PersonHolderBox from '../components/Common/PersonHolderBox';
import PersonHolderBoxContextAware from '../components/Common/PersonHolderBoxContextAware';
import RadioInput from '../components/Common/RadioInput';
import SalesAndServiceCentersHolderTwoColumns from '../components/Common/SalesAndServiceCentersHolderTwoColumns';
import ContactPointInfo from '../components/Common/SalesAndServiceCentersHolderTwoColumns/ContactPointInfo';
import FavouriteContactPointButton from '../components/Common/SalesAndServiceCentersHolderTwoColumns/ContactPointInfo/FavouriteContactPointButton';
import SalesAndServiceCentersBackTo from '../components/Common/SalesAndServiceCentersHolderTwoColumns/SalesAndServiceCentersBackTo';
import SalesAndServicePointsFilterCategory from '../components/Common/SalesAndServiceCentersHolderTwoColumns/SalesAndServicePointsFilterCategory';
import SalesAndServicePointsFilterHeader from '../components/Common/SalesAndServiceCentersHolderTwoColumns/SalesAndServicePointsFilterHeader';
import SalesAndServicePointsFiltersWrapper from '../components/Common/SalesAndServiceCentersHolderTwoColumns/SalesAndServicePointsFiltersWrapper';
import SalesAndServicePointsList from '../components/Common/SalesAndServiceCentersHolderTwoColumns/SalesAndServicePointsList';
import SearchLocationInput from '../components/Common/SalesAndServiceCentersHolderTwoColumns/SearchLocationInput';
import SalesAndServicePointsMap from '../components/Common/SalesAndServicePointsMap';
import ScrollSnap from '../components/Common/ScrollSnap';
import SelectLanguage from '../components/Common/SelectLanguage';
import SlideOver from '../components/Common/SlideOver';
import SolutionCardsGalleryComponent from '../components/Common/SolutionCardsGalleryComponent';
import AXAGSolutionCardsGallery from '../components/Common/SolutionCardsGalleryComponent/AXAGSolutionCardsGallery';
import DesktopGallery from '../components/Common/SolutionCardsGalleryComponent/DesktopGallery';
import LAGSolutionCardsGallery from '../components/Common/SolutionCardsGalleryComponent/LAGSolutionCardsGallery';
import MobileGallery from '../components/Common/SolutionCardsGalleryComponent/MobileGallery';
import SolutionCard from '../components/Common/SolutionCardsGalleryComponent/SolutionCard';
import SolutionCardsGallery from '../components/Common/SolutionCardsGalleryComponent/SolutionCardsGallery';
import WELDYSolutionCardsGallery from '../components/Common/SolutionCardsGalleryComponent/WELDYSolutionCardsGallery';
import SolutionHero from '../components/Common/SolutionHero';
import SpaceComponent from '../components/Common/SpaceComponent';
import Spinner from '../components/Common/Spinner';
import StartPageHero from '../components/Common/StartPageHero';
import StickyMenu from '../components/Common/StickyMenu';
import StickyMenuItem from '../components/Common/StickyMenu/StickyMenuItem';
import Table from '../components/Common/Table';
import Availability from '../components/Common/Table/Cell/Availability';
import BoldText from '../components/Common/Table/Cell/BoldText';
import FulfillmentStatus from '../components/Common/Table/Cell/FulfillmentStatus';
import ImageWithText from '../components/Common/Table/Cell/ImageWithText';
import Money from '../components/Common/Table/Cell/Money';
import Price from '../components/Common/Table/Cell/Price';
import TextCell from '../components/Common/Table/Cell/TextCell';
import Text from '../components/Common/Text';
import UpDown from '../components/Common/UpDown';
import VideoPromotionBox from '../components/Common/VideoPromotionBox';
import ConfirmationDialog from '../components/ConfirmationDialog';
import ConditionalLink from '../components/Content/ConditionalLink';
import ImageVideoHero from '../components/Content/ImageVideo Hero';
import ImageSlide from '../components/Content/ImageVideo Hero/ImageSlide';
import ProgressBar from '../components/Content/ImageVideo Hero/ProgressBar';
import TextBox from '../components/Content/ImageVideo Hero/TextBox';
import VideoSlide from '../components/Content/ImageVideo Hero/VideoSlide';
import AccessoriesOmnibox from '../components/Coveo/AccessoriesOmnibox';
import AccessoriesResultItem from '../components/Coveo/AccessoriesResultItem';
import CategoryFacet from '../components/Coveo/CategoryFacet';
import CoveoOmnibox from '../components/Coveo/CoveoOmnibox';
import CoveoProductCarousel from '../components/Coveo/CoveoProductCarousel';
import CoveoProductCarouselCard from '../components/Coveo/CoveoProductCarousel/CoveoProductCarouselCard';
import Facet from '../components/Coveo/Facet';
import FacetBreadcrumbs from '../components/Coveo/FacetBreadcrumbs';
import FacetManager from '../components/Coveo/FacetManager';
import FacetsModal from '../components/Coveo/FacetsModal';
import FloatingFilterToggle from '../components/Coveo/FloatingFilterToggle';
import ImageFacet from '../components/Coveo/ImageFacet';
import InstantResultItem from '../components/Coveo/InstantResultItem';
import DownloadsLister from '../components/Coveo/Lister/DownloadsLister';
import EventsLister from '../components/Coveo/Lister/EventsLister';
import GeneralDownloadsLister from '../components/Coveo/Lister/GeneralDownloadsLister';
import JobsLister from '../components/Coveo/Lister/JobsLister';
import AccessoriesLister from '../components/Coveo/Lister/Products/AccessoriesLister';
import ExtrusionWeldersLister from '../components/Coveo/Lister/Products/ExtrusionWeldersLister';
import HeatGunsLister from '../components/Coveo/Lister/Products/HeatGunsLister';
import IndustrialHotAirDevicesLister from '../components/Coveo/Lister/Products/IndustrialHotAirDevicesLister';
import InfraredHeatersLister from '../components/Coveo/Lister/Products/InfraredHeatersLister';
import InfraredSourcesLister from '../components/Coveo/Lister/Products/InfraredSourcesLister';
import LaserGasDetectionLister from '../components/Coveo/Lister/Products/LaserGasDetectionLister';
import LaserSystemsLister from '../components/Coveo/Lister/Products/LaserSystemsLister';
import MassFlowDevicesLister from '../components/Coveo/Lister/Products/MassFlowDevicesLister';
import MicroOpticsLister from '../components/Coveo/Lister/Products/MicroOpticsLister';
import WaferProcessingServicesLister from '../components/Coveo/Lister/Products/WaferProcessingServicesLister';
import WeldingMachinesLister from '../components/Coveo/Lister/Products/WeldingMachinesLister';
import WeldyAccessoriesLister from '../components/Coveo/Lister/Products/WeldyAccessoriesLister';
import WeldyExtrusionWeldersLister from '../components/Coveo/Lister/Products/WeldyExtrusionWeldersLister';
import WeldyHeatGunsLister from '../components/Coveo/Lister/Products/WeldyHeatGunsLister';
import WeldyWeldingMachinesLister from '../components/Coveo/Lister/Products/WeldyWeldingMachinesLister';
import StoriesLister from '../components/Coveo/Lister/StoriesLister';
import LoadMore from '../components/Coveo/LoadMore';
import NoResults from '../components/Coveo/NoResults';
import PageOmnibox from '../components/Coveo/PageOmnibox';
import RangeFacet from '../components/Coveo/RangeFacet';
import CareerResultItem from '../components/Coveo/ResultItem/CareerResultItem';
import DownloadResultItem from '../components/Coveo/ResultItem/DownloadResultItem';
import EventResultItem from '../components/Coveo/ResultItem/EventResultItem';
import ExpertiseResultItem from '../components/Coveo/ResultItem/ExpertiseResultItem';
import GeneralDownloadsResultItem from '../components/Coveo/ResultItem/GeneralDownloadsResultItem';
import HeroResultItem from '../components/Coveo/ResultItem/HeroResultItem';
import ProductResultItem from '../components/Coveo/ResultItem/ProductResultItem';
import SearchCareerResultItem from '../components/Coveo/ResultItem/SearchCareerResultItem';
import SolutionResultItem from '../components/Coveo/ResultItem/SolutionResultItem';
import StoryResultItem from '../components/Coveo/ResultItem/StoryResultItem';
import UniversalCareerResultItem from '../components/Coveo/ResultItem/UniversalCareerResultItem';
import UniversalSearchCareerResultItem from '../components/Coveo/ResultItem/UniversalSearchCareerResultItem';
import UniversalStoryResultItem from '../components/Coveo/ResultItem/UniversalStoryResultItem';
import ResultLink from '../components/Coveo/ResultLink';
import SearchResultHeading from '../components/Coveo/SearchResultHeading';
import SearchResultList from '../components/Coveo/SearchResultList';
import SearchResults from '../components/Coveo/SearchResults';
import SearchResultTab from '../components/Coveo/SearchResultTab';
import SearchResultTabs from '../components/Coveo/SearchResultTabs';
import SimpleSearchOmnibox from '../components/Coveo/SimpleSearchOmnibox';
import SuggestionResultItem from '../components/Coveo/SuggestionResultItem';
import Footer from '../components/Footer';
import FooterGeneralLink from '../components/Footer/Footer General Link';
import FooterColumn from '../components/Footer/FooterColumn';
import FooterCopyright from '../components/Footer/FooterCopyright';
import FooterDetailsColumn from '../components/Footer/FooterDetailsColumn';
import FooterLabel from '../components/Footer/FooterLabel';
import FooterLinkColumn from '../components/Footer/FooterLinkColumn';
import SocialLink from '../components/Footer/SocialLink';
import ContactCareerCard from '../components/Forms/ContactCareerCard';
import ContactForm from '../components/Forms/ContactForm';
import ContactInfo from '../components/Forms/ContactInfo';
import ContactOneColumn from '../components/Forms/ContactOneColumn';
import ContactProductCard from '../components/Forms/ContactProductCard';
import ContactTwoColumnNew from '../components/Forms/ContactTwoColumnNew';
import ExpandedFormWrapper from '../components/Forms/ExpandedFormWrapper';
import FormWrapper from '../components/Forms/FormWrapper';
import SuccessMessage from '../components/Forms/SuccessMessage';
import CustomerButton from '../components/LeisterTechnologies/CustomerButton';
import HeroCareer from '../components/LeisterTechnologies/Hero Career';
import HeroStory from '../components/LeisterTechnologies/Hero Story';
import HeroTitleWithOverline from '../components/LeisterTechnologies/HeroTitleWithOverline';
import History from '../components/LeisterTechnologies/History';
import HistoryItem from '../components/LeisterTechnologies/History/HistoryItem';
import LinkElement from '../components/LeisterTechnologies/LinkElement';
import MediaCarousel from '../components/LeisterTechnologies/MediaCarousel';
import MediaCarouselElement from '../components/LeisterTechnologies/MediaCarousel/MediaCarouselElement';
import MediaCarouselFrame from '../components/LeisterTechnologies/MediaCarousel/MediaCarouselFrame';
import MyLeisterAppPromotion from '../components/LeisterTechnologies/MyLeisterAppPromotion';
import MyLeisterRegistrationPromotion from '../components/LeisterTechnologies/MyLeisterRegistrationPromotion';
import NewsletterConfirmation from '../components/LeisterTechnologies/NewsletterConfirmation';
import NewsletterSubscription from '../components/LeisterTechnologies/NewsletterSubscription';
import PageBackLink from '../components/LeisterTechnologies/PageBackLink';
import PromotionBox from '../components/LeisterTechnologies/PromotionBox';
import Quote from '../components/LeisterTechnologies/Quote';
import RichTextWithCheckmarks from '../components/LeisterTechnologies/RichTextWithCheckmarks';
import CheckmarksItem from '../components/LeisterTechnologies/RichTextWithCheckmarks/CheckmarksItem';
import ShareEmailLink from '../components/LeisterTechnologies/ShareEmailLink';
import ShareSocialLink from '../components/LeisterTechnologies/ShareSocialLink';
import StoreLink from '../components/LeisterTechnologies/StoreLink';
import StoryBoxComponent from '../components/LeisterTechnologies/StoryBoxComponent';
import AXAGStoryBox from '../components/LeisterTechnologies/StoryBoxComponent/AXAGStoryBox';
import LAGStoryBox from '../components/LeisterTechnologies/StoryBoxComponent/LAGStoryBox';
import StoryBox from '../components/LeisterTechnologies/StoryBoxComponent/StoryBox';
import WELDYStoryBox from '../components/LeisterTechnologies/StoryBoxComponent/WELDYStoryBox';
import ThreeColumnCategory from '../components/LeisterTechnologies/ThreeColumnCategory';
import ColumnCategory from '../components/LeisterTechnologies/ThreeColumnCategory/ColumnCategory';
import ColumnCategoryItem from '../components/LeisterTechnologies/ThreeColumnCategory/ColumnCategoryItem';
import TwoColumnContentBlock from '../components/LeisterTechnologies/TwoColumnContentBlock';
import UniversalJobHero from '../components/LeisterTechnologies/Universal Job Hero';
import UniversalStoryHero from '../components/LeisterTechnologies/Universal Story Hero';
import UniversalHero from '../components/LeisterTechnologies/UniversalHero';
import UniversalStoryLinkerLR from '../components/LeisterTechnologies/UniversalStoryLinkerLR';
import Menu from '../components/Menu';
import Accordion from '../components/Menu/Accordion';
import Breadcrumb from '../components/Menu/Breadcrumb';
import DesktopMenu from '../components/Menu/DesktopMenu';
import IconsMenu from '../components/Menu/IconsMenu';
import MenuFlyout from '../components/Menu/MenuFlyout';
import OneSectionLayout from '../components/Menu/MenuFlyout/OneSectionLayout';
import ProductsLayout from '../components/Menu/MenuFlyout/ProductsLayout';
import ThreeSectionsLayout from '../components/Menu/MenuFlyout/ThreeSectionsLayout';
import TwoSectionsLayout from '../components/Menu/MenuFlyout/TwoSectionsLayout';
import MenuInfo from '../components/Menu/MenuInfo';
import MenuTabs from '../components/Menu/MenuTabs';
import MobileMenu from '../components/Menu/MobileMenu';
import MyAccountDesktopMenu from '../components/Menu/MyAccountDesktopMenu';
import MyAccountMobileMenu from '../components/Menu/MyAccountMobileMenu';
import SubMenuItems from '../components/Menu/SubMenuItems';
import SubMenuItemsDesktop from '../components/Menu/SubMenuItems/SubMenuItemsDesktop';
import SubMenuItemsMobile from '../components/Menu/SubMenuItems/SubMenuItemsMobile';
import MetaDataForShare from '../components/MetaDataForShare';
import NotFound from '../components/NotFound';
import OverlayDialog from '../components/OverlayDialog';
import Accessories from '../components/Product/Accessories';
import SubCategories from '../components/Product/Accessories/Components/SubCategories';
import SubCategoriesItems from '../components/Product/Accessories/Components/SubCategoriesItems';
import AccessoriesHero from '../components/Product/AccessoriesHero';
import AllDownloads from '../components/Product/AllDownloads';
import AllDownloadItem from '../components/Product/AllDownloads/AllDownloadItem';
import ProductInfo from '../components/Product/AllDownloads/ProductInfo';
import Benefits from '../components/Product/Benefits';
import BenefitsWithCheckmarks from '../components/Product/Benefits/BenefitsWithCheckmarks';
import BenefitsWithImages from '../components/Product/Benefits/BenefitsWithImages';
import CompatibleProducts from '../components/Product/CompatibleProducts';
import CompatibleProductsCard from '../components/Product/CompatibleProducts/CompatibleProductsCard';
import FilterBanner from '../components/Product/FilterBanner';
import HeroActionButton from '../components/Product/HeroActionButton';
import CompareBox from '../components/Product/HeroActionButton/CompareBox';
import FindADealer from '../components/Product/HeroActionButton/FindADealer';
import ShareBox from '../components/Product/HeroActionButton/ShareBox';
import WishlistBox from '../components/Product/HeroActionButton/WishlistBox';
import WishlistButton from '../components/Product/HeroActionButton/WishlistButton';
import WishlistPopup from '../components/Product/HeroActionButton/WishlistPopup';
import ProductApplications from '../components/Product/ProductApplications';
import ProductBundles from '../components/Product/ProductBundles';
import ProductCard from '../components/Product/ProductCard';
import ProductCarouselThumbnails from '../components/Product/ProductCarouselThumbnails';
import ProductCarouselThumbnailsComponent from '../components/Product/ProductCarouselThumbnails/ProductCarouselThumbnailsComponent';
import CompareApplicationDesktop from '../components/Product/ProductCompare/CompareApplication/CompareApplicationDesktop';
import CompareApplicationList from '../components/Product/ProductCompare/CompareApplication/CompareApplicationList';
import CompareApplicationMobile from '../components/Product/ProductCompare/CompareApplication/CompareApplicationMobile';
import CompareCategories from '../components/Product/ProductCompare/CompareCategories';
import CompareCategory from '../components/Product/ProductCompare/CompareCategories/CompareCategory';
import CompareFloatingIcon from '../components/Product/ProductCompare/CompareFloatingIcon';
import CompareProductCard from '../components/Product/ProductCompare/CompareProductCard';
import CompareProducts from '../components/Product/ProductCompare/CompareProducts';
import CompareProductsHero from '../components/Product/ProductCompare/CompareProductsHero';
import CompareProductsWithStickyMenu from '../components/Product/ProductCompare/CompareProductsWithStickyMenu';
import CompareStickyMenu from '../components/Product/ProductCompare/CompareStickyMenu';
import CompareStickyMenuCard from '../components/Product/ProductCompare/CompareStickyMenu/CompareStickyMenuCard';
import CompareTechnicalSpecsList from '../components/Product/ProductCompare/CompareTechnicalSpecsList';
import CompareTechnicalSpecs from '../components/Product/ProductCompare/CompareTechnicalSpecsList/CompareTechnicalSpecs';
import CompareTechnicalsSpecsMobile from '../components/Product/ProductCompare/CompareTechnicalSpecsList/CompareTechnicalsSpecsMobile';
import CompareTechnicalSpecsNavigationHeader from '../components/Product/ProductCompare/CompareTechnicalSpecsList/CompareTechnicalsSpecsMobile/CompareTechnicalSpecsNavigationHeader';
import CompareUSP from '../components/Product/ProductCompare/CompareUSP';
import CompareUSPItem from '../components/Product/ProductCompare/CompareUSP/CompareUSPItem';
import NoComparedData from '../components/Product/ProductCompare/NoComparedData';
import ProductComparisonAccordion from '../components/Product/ProductCompare/ProductComparisonAccordion';
import ProductDetails from '../components/Product/ProductDetails';
import ProductDetailsHero from '../components/Product/ProductDetailsHero';
import ProductDetailsLabel from '../components/Product/ProductDetailsLabel';
import ProductDownloads from '../components/Product/ProductDownloads';
import ProductHeroMainImage from '../components/Product/ProductHeroMainImage';
import ProductsCarousel from '../components/Product/ProductsCarousel';
import ProductsLightBox from '../components/Product/ProductsLightBox';
import ProductStickyMenu from '../components/Product/ProductStickyMenu';
import ProductTitle from '../components/Product/ProductTitle';
import SimilarAccessories from '../components/Product/SimilarAccessories';
import SimilarAccessoriesForMasterPage from '../components/Product/SimilarAccessoriesForMasterPage';
import SimilarProducts from '../components/Product/SimilarProducts';
import SimilarProductCard from '../components/Product/SimilarProducts/SimilarProductCard';
import StoriesPromotionBoxComponent from '../components/Product/StoriesPromotionBoxComponent';
import LAGStoriesPromotionBox from '../components/Product/StoriesPromotionBoxComponent/LAGStoriesPromotionBox';
import StoriesPromotionBox from '../components/Product/StoriesPromotionBoxComponent/StoriesPromotionBox';
import StoryProductCard from '../components/Product/StoryProductCard';
import Techspec from '../components/Product/Techspec';
import TehnicalSpecifications from '../components/Product/TehnicalSpecifications';
import USP from '../components/Product/USP';
import USPAccessories from '../components/Product/USPAccessories';
import VariantSelector from '../components/Product/VariantSelector';
import VideoCampaign from '../components/Product/VideoCampaign';
import WishlistComponent from '../components/Product/WishlistComponent';
import AddWishListButton from '../components/Product/WishlistComponent/AddWishListButton';
import AuthenticatedUserWishlists from '../components/Product/WishlistComponent/AuthenticatedUserWishlists';
import CreateWishList from '../components/Product/WishlistComponent/CreateWishList';
import ItemProductWishlist from '../components/Product/WishlistComponent/ItemProductWishlist';
import WishlistItems from '../components/Product/WishlistComponent/WishlistItems';
import WishlistRegistrationBenefits from '../components/Product/WishlistComponent/WishlistRegistrationBenefits';
import RedirectUrl from '../components/RedirectUrl';
import RemoveApprovalOverlay from '../components/RemoveApprovalOverlay';
import HeroTopSalesAndServicePoint from '../components/SalesAndServices/HeroTopSalesAndServicePoint';
import SalesAndServicePointDetailPageHero from '../components/SalesAndServices/SalesAndServicePointDetailPageHero';
import SalesAndServicesBorderLine from '../components/SalesAndServices/SalesAndServicesBorderLine';
import AddToCart from '../components/Shopify/AddToCart';
import AddToCartNotification from '../components/Shopify/AddToCartNotification';
import AddToCartSlideOver from '../components/Shopify/AddToCartSlideOver';
import AddToCartTeaser from '../components/Shopify/AddToCartTeaser';
import AvailabilityTooltip from '../components/Shopify/AvailabilityTooltip';
import BundleDisplay from '../components/Shopify/Bundle/BundleDisplay';
import BundleItem from '../components/Shopify/Bundle/BundleItem';
import BundleSectionLink from '../components/Shopify/Bundle/BundleSectionLink';
import Cart from '../components/Shopify/Cart';
import CartItem from '../components/Shopify/Cart/CartItem';
import DeleteItemButton from '../components/Shopify/Cart/DeleteItemButton';
import EditItemQuantityButton from '../components/Shopify/Cart/EditItemQuantityButton';
import Modal from '../components/Shopify/Cart/Modal';
import OpenCart from '../components/Shopify/Cart/OpenCart';
import FindADealerActions from '../components/Shopify/FindADealerActions';
import FloatingCartToggle from '../components/Shopify/FloatingCartToggle';
import ProductVariantSelector from '../components/Shopify/ProductVariantSelector';
import SelectVariantMobile from '../components/Shopify/SelectVariantMobile';
import SitecoreJSSReactForms from '../components/SitecoreJSSReactForms';
import Button from '../components/SitecoreJSSReactForms/components/field-templates/Button';

const components = new Map();
components.set('FavouriteContact', FavouriteContact);
components.set('My Address List', MyAddressList);
components.set('MyAccountHeadline', MyAccountHeadline);
components.set('MyAccountTabsComponent', MyAccountTabsComponent);
components.set('MyAccountDeviceRegistration', MyAccountDeviceRegistration);
components.set('AddDevice', AddDevice);
components.set('ErrorMessageWithSupport', ErrorMessageWithSupport);
components.set('ConfirmationBanner', ConfirmationBanner);
components.set('DeviceConfirmationButtons', DeviceConfirmationButtons);
components.set('DevicesAccountInformation', DevicesAccountInformation);
components.set('NewAddedDeviceList', NewAddedDeviceList);
components.set('OverlayFindSerialAndArticle', OverlayFindSerialAndArticle);
components.set('RegisterDevicesList', RegisterDevicesList);
components.set('TitleAndDescription', TitleAndDescription);
components.set('MyAccountDeviceList', MyAccountDeviceList);
components.set('AddDeviceButton', AddDeviceButton);
components.set('DeviceFilters', DeviceFilters);
components.set('DeviceList', DeviceList);
components.set('DeviceCard', DeviceCard);
components.set('MyNewsletters', MyNewsletters);
components.set('FulfillmentStatusTag', FulfillmentStatusTag);
components.set('LineItemsMobile', LineItemsMobile);
components.set('MyAccountOrderDetails', MyAccountOrderDetails);
components.set('MyAccountOrderList', MyAccountOrderList);
components.set('OrderListMobile', OrderListMobile);
components.set('MyProfileComponent', MyProfileComponent);
components.set('AccountInformations', AccountInformations);
components.set('CompanyInformations', CompanyInformations);
components.set('PersonalInformations', PersonalInformations);
components.set('AlertBox', AlertBox);
components.set('BackToLink', BackToLink);
components.set('CareerPromotionBox', CareerPromotionBox);
components.set('CategoryPipeDate', CategoryPipeDate);
components.set('ContentAccordion', ContentAccordion);
components.set('ContentAccordionElements', ContentAccordionElements);
components.set('BacktoOverview', BacktoOverview);
components.set('EventInformation', EventInformation);
components.set('EventMap', EventMap);
components.set('ImageWithRichText', ImageWithRichText);
components.set('ReadMoreRichText', ReadMoreRichText);
components.set('RichTextTeaser', RichTextTeaser);
components.set('VideoWithRichText', VideoWithRichText);
components.set('Dialog', Dialog);
components.set('DownloadBox', DownloadBox);
components.set('DownloadItem', DownloadItem);
components.set('Dropdown', Dropdown);
components.set('FilterToggle', FilterToggle);
components.set('GatedDownload', GatedDownload);
components.set('GeneralLink', GeneralLink);
components.set('HeaderTableTeaser', HeaderTableTeaser);
components.set('TableRowTeaser', TableRowTeaser);
components.set('HeadlineRichtextTeaser', HeadlineRichtextTeaser);
components.set('HeadlineWithTitleAndSubtitle', HeadlineWithTitleAndSubtitle);
components.set('Hero Expertise', HeroExpertise);
components.set('HeroListingTitleWithOverline', HeroListingTitleWithOverline);
components.set('Icon', Icon);
components.set('IconLink', IconLink);
components.set('ImageLeftTeaser', ImageLeftTeaser);
components.set('ImageRightTeaser', ImageRightTeaser);
components.set('AXAGImageSlider169', AXAGImageSlider169);
components.set('AXAGImageSlider31', AXAGImageSlider31);
components.set('ImageSlider169', ImageSlider169);
components.set('ImageSlider31', ImageSlider31);
components.set('LAGImageSlider169', LAGImageSlider169);
components.set('LAGImageSlider31', LAGImageSlider31);
components.set('ImageTextRight', ImageTextRight);
components.set('InlineConfirmationDialog', InlineConfirmationDialog);
components.set('InlineError', InlineError);
components.set('LanguageFlyout', LanguageFlyout);
components.set('LightboxVideo', LightboxVideo);
components.set('LinkerCarouselComponent', LinkerCarouselComponent);
components.set('AXAGLinkerCarousel', AXAGLinkerCarousel);
components.set('LAGLinkerCarousel', LAGLinkerCarousel);
components.set('LinkerCarousel', LinkerCarousel);
components.set('WELDYLinkerCarousel', WELDYLinkerCarousel);
components.set('ListingPageTitleWithDescription', ListingPageTitleWithDescription);
components.set('Logo', Logo);
components.set('MediaGalleryTeaser', MediaGalleryTeaser);
components.set('ObjectSlider', ObjectSlider);
components.set('PageDescriptionTeaser', PageDescriptionTeaser);
components.set('PageLinker', PageLinker);
components.set('PageLinkerAutomaticallyComponent', PageLinkerAutomaticallyComponent);
components.set('AXAGPageLinkerAutomatically', AXAGPageLinkerAutomatically);
components.set('LAGPageLinkerAutomatically', LAGPageLinkerAutomatically);
components.set('PageLinkerAutomatically', PageLinkerAutomatically);
components.set('WELDYPageLinkerAutomatically', WELDYPageLinkerAutomatically);
components.set('PageLinkerList', PageLinkerList);
components.set('PersonHolderBox', PersonHolderBox);
components.set('PersonHolderBoxContextAware', PersonHolderBoxContextAware);
components.set('RadioInput', RadioInput);
components.set('SalesAndServiceCentersHolderTwoColumns', SalesAndServiceCentersHolderTwoColumns);
components.set('ContactPointInfo', ContactPointInfo);
components.set('FavouriteContactPointButton', FavouriteContactPointButton);
components.set('SalesAndServiceCentersBackTo', SalesAndServiceCentersBackTo);
components.set('SalesAndServicePointsFilterCategory', SalesAndServicePointsFilterCategory);
components.set('SalesAndServicePointsFilterHeader', SalesAndServicePointsFilterHeader);
components.set('SalesAndServicePointsFiltersWrapper', SalesAndServicePointsFiltersWrapper);
components.set('SalesAndServicePointsList', SalesAndServicePointsList);
components.set('SearchLocationInput', SearchLocationInput);
components.set('SalesAndServicePointsMap', SalesAndServicePointsMap);
components.set('ScrollSnap', ScrollSnap);
components.set('SelectLanguage', SelectLanguage);
components.set('SlideOver', SlideOver);
components.set('SolutionCardsGalleryComponent', SolutionCardsGalleryComponent);
components.set('AXAGSolutionCardsGallery', AXAGSolutionCardsGallery);
components.set('DesktopGallery', DesktopGallery);
components.set('LAGSolutionCardsGallery', LAGSolutionCardsGallery);
components.set('MobileGallery', MobileGallery);
components.set('SolutionCard', SolutionCard);
components.set('SolutionCardsGallery', SolutionCardsGallery);
components.set('WELDYSolutionCardsGallery', WELDYSolutionCardsGallery);
components.set('SolutionHero', SolutionHero);
components.set('SpaceComponent', SpaceComponent);
components.set('Spinner', Spinner);
components.set('StartPageHero', StartPageHero);
components.set('StickyMenu', StickyMenu);
components.set('StickyMenuItem', StickyMenuItem);
components.set('Table', Table);
components.set('Availability', Availability);
components.set('BoldText', BoldText);
components.set('FulfillmentStatus', FulfillmentStatus);
components.set('ImageWithText', ImageWithText);
components.set('Money', Money);
components.set('Price', Price);
components.set('TextCell', TextCell);
components.set('Text', Text);
components.set('UpDown', UpDown);
components.set('VideoPromotionBox', VideoPromotionBox);
components.set('ConfirmationDialog', ConfirmationDialog);
components.set('ConditionalLink', ConditionalLink);
components.set('ImageVideo Hero', ImageVideoHero);
components.set('ImageSlide', ImageSlide);
components.set('ProgressBar', ProgressBar);
components.set('TextBox', TextBox);
components.set('VideoSlide', VideoSlide);
components.set('AccessoriesOmnibox', AccessoriesOmnibox);
components.set('AccessoriesResultItem', AccessoriesResultItem);
components.set('CategoryFacet', CategoryFacet);
components.set('CoveoOmnibox', CoveoOmnibox);
components.set('CoveoProductCarousel', CoveoProductCarousel);
components.set('CoveoProductCarouselCard', CoveoProductCarouselCard);
components.set('Facet', Facet);
components.set('FacetBreadcrumbs', FacetBreadcrumbs);
components.set('FacetManager', FacetManager);
components.set('FacetsModal', FacetsModal);
components.set('FloatingFilterToggle', FloatingFilterToggle);
components.set('ImageFacet', ImageFacet);
components.set('InstantResultItem', InstantResultItem);
components.set('DownloadsLister', DownloadsLister);
components.set('EventsLister', EventsLister);
components.set('GeneralDownloadsLister', GeneralDownloadsLister);
components.set('JobsLister', JobsLister);
components.set('AccessoriesLister', AccessoriesLister);
components.set('ExtrusionWeldersLister', ExtrusionWeldersLister);
components.set('HeatGunsLister', HeatGunsLister);
components.set('IndustrialHotAirDevicesLister', IndustrialHotAirDevicesLister);
components.set('InfraredHeatersLister', InfraredHeatersLister);
components.set('InfraredSourcesLister', InfraredSourcesLister);
components.set('LaserGasDetectionLister', LaserGasDetectionLister);
components.set('LaserSystemsLister', LaserSystemsLister);
components.set('MassFlowDevicesLister', MassFlowDevicesLister);
components.set('MicroOpticsLister', MicroOpticsLister);
components.set('WaferProcessingServicesLister', WaferProcessingServicesLister);
components.set('WeldingMachinesLister', WeldingMachinesLister);
components.set('WeldyAccessoriesLister', WeldyAccessoriesLister);
components.set('WeldyExtrusionWeldersLister', WeldyExtrusionWeldersLister);
components.set('WeldyHeatGunsLister', WeldyHeatGunsLister);
components.set('WeldyWeldingMachinesLister', WeldyWeldingMachinesLister);
components.set('StoriesLister', StoriesLister);
components.set('LoadMore', LoadMore);
components.set('NoResults', NoResults);
components.set('PageOmnibox', PageOmnibox);
components.set('RangeFacet', RangeFacet);
components.set('CareerResultItem', CareerResultItem);
components.set('DownloadResultItem', DownloadResultItem);
components.set('EventResultItem', EventResultItem);
components.set('ExpertiseResultItem', ExpertiseResultItem);
components.set('GeneralDownloadsResultItem', GeneralDownloadsResultItem);
components.set('HeroResultItem', HeroResultItem);
components.set('ProductResultItem', ProductResultItem);
components.set('SearchCareerResultItem', SearchCareerResultItem);
components.set('SolutionResultItem', SolutionResultItem);
components.set('StoryResultItem', StoryResultItem);
components.set('UniversalCareerResultItem', UniversalCareerResultItem);
components.set('UniversalSearchCareerResultItem', UniversalSearchCareerResultItem);
components.set('UniversalStoryResultItem', UniversalStoryResultItem);
components.set('ResultLink', ResultLink);
components.set('SearchResultHeading', SearchResultHeading);
components.set('SearchResultList', SearchResultList);
components.set('SearchResults', SearchResults);
components.set('SearchResultTab', SearchResultTab);
components.set('SearchResultTabs', SearchResultTabs);
components.set('SimpleSearchOmnibox', SimpleSearchOmnibox);
components.set('SuggestionResultItem', SuggestionResultItem);
components.set('Footer', Footer);
components.set('Footer General Link', FooterGeneralLink);
components.set('FooterColumn', FooterColumn);
components.set('FooterCopyright', FooterCopyright);
components.set('FooterDetailsColumn', FooterDetailsColumn);
components.set('FooterLabel', FooterLabel);
components.set('FooterLinkColumn', FooterLinkColumn);
components.set('SocialLink', SocialLink);
components.set('ContactCareerCard', ContactCareerCard);
components.set('ContactForm', ContactForm);
components.set('ContactInfo', ContactInfo);
components.set('ContactOneColumn', ContactOneColumn);
components.set('ContactProductCard', ContactProductCard);
components.set('ContactTwoColumnNew', ContactTwoColumnNew);
components.set('ExpandedFormWrapper', ExpandedFormWrapper);
components.set('FormWrapper', FormWrapper);
components.set('SuccessMessage', SuccessMessage);
components.set('CustomerButton', CustomerButton);
components.set('Hero Career', HeroCareer);
components.set('Hero Story', HeroStory);
components.set('HeroTitleWithOverline', HeroTitleWithOverline);
components.set('History', History);
components.set('HistoryItem', HistoryItem);
components.set('LinkElement', LinkElement);
components.set('MediaCarousel', MediaCarousel);
components.set('MediaCarouselElement', MediaCarouselElement);
components.set('MediaCarouselFrame', MediaCarouselFrame);
components.set('MyLeisterAppPromotion', MyLeisterAppPromotion);
components.set('MyLeisterRegistrationPromotion', MyLeisterRegistrationPromotion);
components.set('NewsletterConfirmation', NewsletterConfirmation);
components.set('NewsletterSubscription', NewsletterSubscription);
components.set('PageBackLink', PageBackLink);
components.set('PromotionBox', PromotionBox);
components.set('Quote', Quote);
components.set('RichTextWithCheckmarks', RichTextWithCheckmarks);
components.set('CheckmarksItem', CheckmarksItem);
components.set('ShareEmailLink', ShareEmailLink);
components.set('ShareSocialLink', ShareSocialLink);
components.set('StoreLink', StoreLink);
components.set('StoryBoxComponent', StoryBoxComponent);
components.set('AXAGStoryBox', AXAGStoryBox);
components.set('LAGStoryBox', LAGStoryBox);
components.set('StoryBox', StoryBox);
components.set('WELDYStoryBox', WELDYStoryBox);
components.set('ThreeColumnCategory', ThreeColumnCategory);
components.set('ColumnCategory', ColumnCategory);
components.set('ColumnCategoryItem', ColumnCategoryItem);
components.set('TwoColumnContentBlock', TwoColumnContentBlock);
components.set('Universal Job Hero', UniversalJobHero);
components.set('Universal Story Hero', UniversalStoryHero);
components.set('UniversalHero', UniversalHero);
components.set('UniversalStoryLinkerLR', UniversalStoryLinkerLR);
components.set('Menu', Menu);
components.set('Accordion', Accordion);
components.set('Breadcrumb', Breadcrumb);
components.set('DesktopMenu', DesktopMenu);
components.set('IconsMenu', IconsMenu);
components.set('MenuFlyout', MenuFlyout);
components.set('OneSectionLayout', OneSectionLayout);
components.set('ProductsLayout', ProductsLayout);
components.set('ThreeSectionsLayout', ThreeSectionsLayout);
components.set('TwoSectionsLayout', TwoSectionsLayout);
components.set('MenuInfo', MenuInfo);
components.set('MenuTabs', MenuTabs);
components.set('MobileMenu', MobileMenu);
components.set('MyAccountDesktopMenu', MyAccountDesktopMenu);
components.set('MyAccountMobileMenu', MyAccountMobileMenu);
components.set('SubMenuItems', SubMenuItems);
components.set('SubMenuItemsDesktop', SubMenuItemsDesktop);
components.set('SubMenuItemsMobile', SubMenuItemsMobile);
components.set('MetaDataForShare', MetaDataForShare);
components.set('NotFound', NotFound);
components.set('OverlayDialog', OverlayDialog);
components.set('Accessories', Accessories);
components.set('SubCategories', SubCategories);
components.set('SubCategoriesItems', SubCategoriesItems);
components.set('AccessoriesHero', AccessoriesHero);
components.set('AllDownloads', AllDownloads);
components.set('AllDownloadItem', AllDownloadItem);
components.set('ProductInfo', ProductInfo);
components.set('Benefits', Benefits);
components.set('BenefitsWithCheckmarks', BenefitsWithCheckmarks);
components.set('BenefitsWithImages', BenefitsWithImages);
components.set('CompatibleProducts', CompatibleProducts);
components.set('CompatibleProductsCard', CompatibleProductsCard);
components.set('FilterBanner', FilterBanner);
components.set('HeroActionButton', HeroActionButton);
components.set('CompareBox', CompareBox);
components.set('FindADealer', FindADealer);
components.set('ShareBox', ShareBox);
components.set('WishlistBox', WishlistBox);
components.set('WishlistButton', WishlistButton);
components.set('WishlistPopup', WishlistPopup);
components.set('ProductApplications', ProductApplications);
components.set('ProductBundles', ProductBundles);
components.set('ProductCard', ProductCard);
components.set('ProductCarouselThumbnails', ProductCarouselThumbnails);
components.set('ProductCarouselThumbnailsComponent', ProductCarouselThumbnailsComponent);
components.set('CompareApplicationDesktop', CompareApplicationDesktop);
components.set('CompareApplicationList', CompareApplicationList);
components.set('CompareApplicationMobile', CompareApplicationMobile);
components.set('CompareCategories', CompareCategories);
components.set('CompareCategory', CompareCategory);
components.set('CompareFloatingIcon', CompareFloatingIcon);
components.set('CompareProductCard', CompareProductCard);
components.set('CompareProducts', CompareProducts);
components.set('CompareProductsHero', CompareProductsHero);
components.set('CompareProductsWithStickyMenu', CompareProductsWithStickyMenu);
components.set('CompareStickyMenu', CompareStickyMenu);
components.set('CompareStickyMenuCard', CompareStickyMenuCard);
components.set('CompareTechnicalSpecsList', CompareTechnicalSpecsList);
components.set('CompareTechnicalSpecs', CompareTechnicalSpecs);
components.set('CompareTechnicalsSpecsMobile', CompareTechnicalsSpecsMobile);
components.set('CompareTechnicalSpecsNavigationHeader', CompareTechnicalSpecsNavigationHeader);
components.set('CompareUSP', CompareUSP);
components.set('CompareUSPItem', CompareUSPItem);
components.set('NoComparedData', NoComparedData);
components.set('ProductComparisonAccordion', ProductComparisonAccordion);
components.set('ProductDetails', ProductDetails);
components.set('ProductDetailsHero', ProductDetailsHero);
components.set('ProductDetailsLabel', ProductDetailsLabel);
components.set('ProductDownloads', ProductDownloads);
components.set('ProductHeroMainImage', ProductHeroMainImage);
components.set('ProductsCarousel', ProductsCarousel);
components.set('ProductsLightBox', ProductsLightBox);
components.set('ProductStickyMenu', ProductStickyMenu);
components.set('ProductTitle', ProductTitle);
components.set('SimilarAccessories', SimilarAccessories);
components.set('SimilarAccessoriesForMasterPage', SimilarAccessoriesForMasterPage);
components.set('SimilarProducts', SimilarProducts);
components.set('SimilarProductCard', SimilarProductCard);
components.set('StoriesPromotionBoxComponent', StoriesPromotionBoxComponent);
components.set('LAGStoriesPromotionBox', LAGStoriesPromotionBox);
components.set('StoriesPromotionBox', StoriesPromotionBox);
components.set('StoryProductCard', StoryProductCard);
components.set('Techspec', Techspec);
components.set('TehnicalSpecifications', TehnicalSpecifications);
components.set('USP', USP);
components.set('USPAccessories', USPAccessories);
components.set('VariantSelector', VariantSelector);
components.set('VideoCampaign', VideoCampaign);
components.set('WishlistComponent', WishlistComponent);
components.set('AddWishListButton', AddWishListButton);
components.set('AuthenticatedUserWishlists', AuthenticatedUserWishlists);
components.set('CreateWishList', CreateWishList);
components.set('ItemProductWishlist', ItemProductWishlist);
components.set('WishlistItems', WishlistItems);
components.set('WishlistRegistrationBenefits', WishlistRegistrationBenefits);
components.set('RedirectUrl', RedirectUrl);
components.set('RemoveApprovalOverlay', RemoveApprovalOverlay);
components.set('HeroTopSalesAndServicePoint', HeroTopSalesAndServicePoint);
components.set('SalesAndServicePointDetailPageHero', SalesAndServicePointDetailPageHero);
components.set('SalesAndServicesBorderLine', SalesAndServicesBorderLine);
components.set('AddToCart', AddToCart);
components.set('AddToCartNotification', AddToCartNotification);
components.set('AddToCartSlideOver', AddToCartSlideOver);
components.set('AddToCartTeaser', AddToCartTeaser);
components.set('AvailabilityTooltip', AvailabilityTooltip);
components.set('BundleDisplay', BundleDisplay);
components.set('BundleItem', BundleItem);
components.set('BundleSectionLink', BundleSectionLink);
components.set('Cart', Cart);
components.set('CartItem', CartItem);
components.set('DeleteItemButton', DeleteItemButton);
components.set('EditItemQuantityButton', EditItemQuantityButton);
components.set('Modal', Modal);
components.set('OpenCart', OpenCart);
components.set('FindADealerActions', FindADealerActions);
components.set('FloatingCartToggle', FloatingCartToggle);
components.set('ProductVariantSelector', ProductVariantSelector);
components.set('SelectVariantMobile', SelectVariantMobile);
components.set('SitecoreJSSReactForms', SitecoreJSSReactForms);
components.set('Button', Button);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
